export const forgotPasswordCode = () => {
  return {
    title: 'Update Password',
    subtitle: 'Please update your password to continue',
    subtitle_1: 'Please enter the code sent to your email to reset your password.',
    code: 'Code',
    new_password: 'Enter new Password',
    reset_password: 'Reset',
    invalid_password: 'Invalid Password',
    invalid_token: 'Invalid Token',
    min_6_chars: 'The password must have 6 characters or more'
  }
}
